// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"c0bdffbeef8a1de43147","293":"4e71a8c683acaca4aab9","518":"101cb1b66ac09312c1eb","779":"f1c37803f4cfdc5a0b5e"}[chunkId] + ".js";
};